module.exports = __webpack_public_path__ + "static/media/radial_checkin_inversed.766cdb9f.png";